import { type AssetHandler, AssetType, getAssetType, getAssetTypeDisplayName } from '../assetTypes';

import { AnimationConfigHandler } from './handlers/animationConfigHandler';
import { DefaultHandler } from './handlers/defaultHandler';
import { GltfHandler } from './handlers/gltfHandler';
import { JsClassHandler } from './handlers/jsClassHandler';
import { MeshCombinationHandler } from './handlers/meshCombinationHandler';
import { PrefabHandler } from './handlers/prefabHandler';
import { ResourceHandler } from './handlers/resourceHandler';
import { SceneHandler } from './handlers/sceneHandler';
import { SkeletonProfileHandler } from './handlers/skeletonProfileHandler';
import { SourceCodeHandler } from './handlers/sourceCodeHandler';
import { VfxHandler } from './handlers/vfxHandler';

import type { IAssetFile } from '@/editor/store/models';

export { type AssetHandler, AssetType, getAssetType, getAssetTypeDisplayName, type IAssetFile };


const defaultHandler = new DefaultHandler();
const sceneHandler = new SceneHandler();
const prefabHandler = new PrefabHandler();
const gltfHandler = new GltfHandler();
const sourceCodeHandler = new SourceCodeHandler();
const jsClassHandler = new JsClassHandler();
const meshCombinationHandler = new MeshCombinationHandler();
const resourceHandler = new ResourceHandler();
const vfxHandler = new VfxHandler();
const animationConfigHandler = new AnimationConfigHandler();
const skeletonProfileHandler = new SkeletonProfileHandler();

const handlers: Map<AssetType, AssetHandler> = new Map([
  [AssetType.Scene, sceneHandler],
  [AssetType.Prefab, prefabHandler],
  [AssetType.Model, gltfHandler],
  [AssetType.SourceCode, sourceCodeHandler],
  [AssetType.JsClass, jsClassHandler],
  [AssetType.MeshCombination, meshCombinationHandler],
  [AssetType.Resource, resourceHandler],
  [AssetType.VFX, vfxHandler],
  [AssetType.AnimationConfig, animationConfigHandler],
  [AssetType.SkeletonProfile, skeletonProfileHandler]
  // Add more handlers here as they are implemented
]);

/**
 * Get the appropriate handler for an asset
 */
export function getAssetHandler(type: AssetType): AssetHandler {
  return handlers.get(type) ?? defaultHandler;
}


